<template>
  <div class="role-user-bd ubv">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button @click="onAddBind" type="warning" v-if="funcView.role_add_user">
            <i class="icon icon-tianjia"></i>
            <span>&ensp;{{ $t('role_user_tjyg') }}</span>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="cancelBind('all')" :disabled="tableSelect.length === 0" v-if="funcView.role_del_user">
            <i class="icon icon-quxiaoguanlian"></i>
            <span>&ensp;{{ $t('role_user_yi_chu_yuan_gong') }}</span>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input width="300px" :placeholder="$t('role_user_ygxmdlzhlxdhyx')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd ub-f1">
      <custom-table stripe type="checkbox" tableCode="portal_roleUser" v-model="tableSelect" :data="userList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
        <el-table-column min-width="110" fixed="right">
          <template slot-scope="scope" v-if="funcView.role_del_user">
            <el-button @click="cancelBind(scope.row)" type="text" size="mini">
              <i class="icon icon-quxiaoguanlian"></i>
              <span>&ensp;{{ $t('role_user_yi_chu_yuan_gong_1') }}</span>
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <role-user-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getRoleUserPage"></role-user-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import roleUserDialog from './role_user_dialog.vue';

// role_user_tjyg: 添加员工// role_user_yi_chu_yuan_gong: 移除员工// role_user_yi_chu_yuan_gong_1: 移除员工// role_user_ygxmdlzhlxdhyx: 员工姓名/登录账号/联系电话/邮箱// role_user_nqdyjxzdygyczggwm: 您确定要将选中的员工移出这个岗位吗？// role_user_nqdyjgygyczggwm: 您确定要将该员工移出这个岗位吗？// role_user_tjygdgw: 添加员工到岗位

export default {
  components: { roleUserDialog },
  props: {
    roleId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        orgId: '',
        isAssociated: 1,
        roleId: '',
      },
      userList: [],
      totalRows: 0,
      isLoading: false,

      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    roleId: function () {
      this.getRoleUserPage();
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_role_user');
    this.getRoleUserPage();
    this.getFuncView();
  },
  methods: {
    // 获取用户列表
    getRoleUserPage: function () {
      if (!this.roleId) {
        return;
      }
      this.formSearch.roleId = this.roleId;
      this.isLoading = true;
      this.$getJSON(apis.RoleUserPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.userList = res.data.list;
        this.totalRows = Number.parseInt(res.data.total, 10);
      });
    },
    // 取消关联
    cancelBind: function (data) {
      const tips = data === 'all' ? this.$t('role_user_nqdyjxzdygyczggwm') : this.$t('role_user_nqdyjgygyczggwm');
      this.$showConfirm(tips)
        .then(() => {
          if (data === 'all') {
            this.onCancelBind(this.tableSelect);
          } else {
            this.onCancelBind([data]);
          }
        })
        .catch(() => {});
    },
    //  提交取消关联
    onCancelBind: function (data) {
      const param = data.map(t => ({
        bizId: t.userId,
        bizName: t.userName,
        bizType: 3,
      }));
      this.$postJSON(apis.RoleUserUnbind, {
        roleId: this.roleId,
        bizInfos: param,
      }).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.getRoleUserPage();
      });
    },
    // 提交绑定关联
    onAddBind: function () {
      this.dialogModel = {
        title: this.$t('role_user_tjygdgw'),
        data: { roleId: this.roleId },
      };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRoleUserPage();
    },
  },
};
</script>

<style lang="scss">
.role-user-bd {
  display: flex;
  flex-direction: column;
  flex: 1;
  .search-hd {
    padding-top: 24px;
    padding-bottom: 2px;
  }
}
</style>
